import "../../i18n/i18n";
import { VehiclesTable } from "./tables/vehiclesTable";
import { useVehicles } from "./useVehicles";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";

export const AddDevicesToProviderTab = () => {
  const { t } = useTranslation();
  const params = useParams();
  const vehiclesListWithId = useVehicles();

  const filteredVehiclesListWithId = useMemo(() => {
    return vehiclesListWithId.filter((v) => !v.dataProvider && !v.deviceId);
  }, [vehiclesListWithId]);

  if (params.tab !== "addDevicesToProvider") {
    return;
  }

  return (
    <StyledContainer>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addDevicesToProvider.description")}
      </StyledDescription>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addDevicesToProvider.description2")}
      </StyledDescription>
      <Spacer y={1} />
      <StyledTableContainer>
        <VehiclesTable
          vehiclesListWithId={filteredVehiclesListWithId}
          pageName="vehiclesOfACompany"
          pageTitle="Add-devices-to-provider"
          dataProvider="FLESPI"
        />
      </StyledTableContainer>
    </StyledContainer>
  );
};

const StyledDescription = styled.div`
  ${typographies["Header/H3"]}
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;
`;

const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;
